import { Link } from "react-router-dom";

export default function Legal() {
  return (
    <div className="min-h-[calc(100vh-4rem)] bg-white py-12" data-testid="legal-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="inline-block px-3 py-1 rounded-full bg-slate-100 text-slate-600 text-[10px] font-bold uppercase tracking-[0.2em] mb-3">Legal</span>
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">Legal & Disclosures</h1>
        <p className="mt-3 text-slate-600">
          myinsuranceclaim.in is an independent claim assistance platform. We are not an insurance company,
          broker, or agent. We do not sell insurance policies. Our role is to help policyholders navigate the
          motor insurance claim process with their respective insurers.
        </p>
        <div className="mt-8 grid sm:grid-cols-2 gap-4">
          {["Terms of Service", "Privacy Policy", "Disclaimer", "Grievance Redressal"].map((t) => (
            <div key={t} className="bg-slate-50 rounded-2xl border border-slate-200 p-5">
              <h3 className="font-heading font-bold text-slate-900">{t}</h3>
              <p className="text-sm text-slate-600 mt-1">Full policy text will be published before public launch. For queries write to <a href="mailto:legal@myinsuranceclaim.in" className="text-[#003DA5] underline">legal@myinsuranceclaim.in</a>.</p>
            </div>
          ))}
        </div>
        <div className="mt-8">
          <Link to="/" className="text-[#003DA5] underline font-semibold">Back to home</Link>
        </div>
      </div>
    </div>
  );
}
